/**
 * SEC-27. Is this string a path inside this origin, judged the way the browser
 * will resolve it rather than the way it reads?
 *
 * `startsWith('/')` is not that test. `new URL(path, 'https://cap.example/x')`
 * sends every one of these to `https://evil.example/`:
 *
 * - `//evil.example`   protocol-relative
 * - `/\evil.example`   the URL parser treats `\` as `/` in http(s)
 *                      (the shape of react-router's GHSA-wrjc-x8rr-h8h6)
 * - `/<TAB>/evil.example`, `/<LF>/...`, `/<CR>/...`  the parser strips tab,
 *                      newline and CR before resolving, so the string judged
 *                      is not the string navigated to
 *
 * So strip what the parser strips, then require one leading `/`, no second
 * one, and no backslash anywhere. No route in this app contains a backslash.
 * Ported from DINC-MHS-Front_End SEC-62.
 *
 * @param {unknown} raw
 * @returns {string|null} The normalized path, or null when it is not internal.
 */
export function internalPath(raw) {
  if (typeof raw !== 'string') return null;
  const path = raw.replace(/[\t\n\r]/g, '');
  if (!path.startsWith('/')) return null;
  if (path.startsWith('//') || path.includes('\\')) return null;
  return path;
}

/**
 * `internalPath`, falling back to `fallback` for anything that is not one.
 * @param {unknown} raw
 * @param {string} [fallback]
 */
export function safeRedirectPath(raw, fallback = '/') {
  return internalPath(raw) ?? fallback;
}
